import { AfterViewInit, Component, contentChild, DOCUMENT, inject, input, TemplateRef, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgTemplateOutlet } from '@angular/common';
import { TourHotkeyListenerComponent } from 'ngx-ui-tour-core';
import { Tour } from './tour';
import { TourStepTemplateRegistry } from './tour-step-template-registry';
import type { IStepOption } from './step-option';

/** Declares, once in the app shell, what every tour step shows; the anchors open it next to themselves. */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- keeps the tour library's element name
  selector: 'tour-step-template',
  template: `
    <ng-template #panel let-step="step">
      <div class="tour-step-panel outline-none" role="dialog" tabindex="-1" [attr.aria-label]="step.title">
        <ng-container *ngTemplateOutlet="stepTemplate() ?? stepTemplateContent() ?? null; context: { step }" />
      </div>
    </ng-template>
  `,
  styleUrl: './tour-step-template.css',
  imports: [NgTemplateOutlet],
})
export class TourStepTemplate extends TourHotkeyListenerComponent implements AfterViewInit {
  readonly stepTemplate = input<TemplateRef<{ step: IStepOption }>>();
  readonly stepTemplateContent = contentChild(TemplateRef);
  private readonly panelTemplate = viewChild.required<TemplateRef<{ step: IStepOption }>>('panel');

  protected override readonly tourService = inject(Tour);
  private readonly templateService = inject(TourStepTemplateRegistry);
  private readonly document = inject(DOCUMENT);
  private focusBeforeTour: HTMLElement | null = null;

  constructor() {
    super();
    this.tourService.start$.pipe(takeUntilDestroyed()).subscribe(() => {
      this.focusBeforeTour = this.document.activeElement as HTMLElement | null;
    });
    this.tourService.end$.pipe(takeUntilDestroyed()).subscribe(() => {
      this.focusBeforeTour?.focus?.({ preventScroll: true });
      this.focusBeforeTour = null;
    });
  }

  ngAfterViewInit(): void {
    this.templateService.panel.set(this.panelTemplate());
  }
}
